import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'

export const NoData = () => {
    const { t } = useEssentials()
    const { insights } = TRANSLATION_KEYS

    return (
        <div className="hc8-p-3x hc8-clr-muted hc8-ta-center">
            <p>{t(insights.sectionNoData)}</p>
        </div>
    )
}
